module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate2.9b08199c08facd7519fe8da601f3604c.png";